import axios from 'axios';

const API = '';

export const listarContasReceber = (params) =>
  axios.get(`${API}/contas-receber`, { params });

export const receberConta = (id, data) =>
  axios.post(`${API}/contas-receber/${id}/receber`, data);

export const listarContasPagar = (params) =>
  axios.get(`${API}/contas-pagar`, { params });

export const pagarConta = (id, data) =>
  axios.post(`${API}/contas-pagar/${id}/pagar`, data);

export const resumoFinanceiro = () =>
  axios.get(`${API}/financeiro/relatorios/resumo`);

export const fluxoCaixa = (params) =>
  axios.get(`${API}/financeiro/relatorios/fluxo-caixa`, { params });
